import {connect} from 'react-redux';
import Contact from './Contact';
import {sendContactMail} from '../../actions/sendContactMail'
import {showGlobalErrorMessage} from "common/actions/globalErrorMessage/showGlobalErrorMessage";

const mapStateToProps = ({
                           user: {...attributes}
                         }) => ({
  user: {...attributes}
});

export default connect(
  mapStateToProps,
  {sendContactMail, showGlobalErrorMessage}
)(Contact);
